function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 9,
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M8 13h10"
});

const SvgCircleMinus = props => React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "none"
}, props), _ref, _ref2);

export default SvgCircleMinus;